/**
 * Contact Locations — map panel switching; active location border accent.
 */
document.addEventListener( 'DOMContentLoaded', () => {
	document.querySelectorAll( '.hoplog-contact-locations' ).forEach( ( block ) => {
		const tabs = block.querySelectorAll( '[data-location-tab]' );
		const panels = block.querySelectorAll( '[data-location-panel]' );

		if ( ! tabs.length || ! panels.length ) {
			return;
		}

		tabs.forEach( ( tab ) => {
			tab.addEventListener( 'click', () => {
				const index = tab.dataset.locationTab;

				tabs.forEach( ( t ) => {
					t.classList.remove( 'border-bright-blue' );
					t.classList.add( 'border-transparent', 'hover:border-black/15' );
					t.setAttribute( 'aria-pressed', 'false' );
				} );
				tab.classList.remove( 'border-transparent', 'hover:border-black/15' );
				tab.classList.add( 'border-bright-blue' );
				tab.setAttribute( 'aria-pressed', 'true' );

				panels.forEach( ( panel ) => {
					panel.classList.toggle( 'hidden', panel.dataset.locationPanel !== index );
				} );
			} );
		} );
	} );
} );
